/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Add_Products_To_OrderInputs */

const vi_pos_add_products_to_order = /** @type {(inputs: Pos_Add_Products_To_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm sản phẩm để đặt hàng`)
};

/**

* @param {Pos_Add_Products_To_OrderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_add_products_to_order = /** @type {((inputs?: Pos_Add_Products_To_OrderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Add_Products_To_OrderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_add_products_to_order(inputs)
});